import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from '@env/environment';

export interface DashboardCountPair {
  total: number;
  year: number;
}

export interface DashboardCounts {
  year?: number;
  transfers: DashboardCountPair;
  mandate: DashboardCountPair;
  vstv_exports: DashboardCountPair;
}

export interface DashboardUser {
  id: number;
  name: string;
  login: string;
  role_id: number;
  role_name: string;
  beusergroup_id?: number;
  admin?: number;
  su?: number;
  dienstnehmer_name?: string | null;
  lastlogin: string;
  lastip: string;
}

export interface DashboardDienstnehmer {
  id: number;
  name: string;
  dienstnummer: number;
  dienstnummer_stvo: number;
  role_id: number;
  role_name: string;
  sachbereich: string;
}

export interface DashboardStats {
  counts: DashboardCounts;
  users: DashboardUser[];
  dienstnehmer: DashboardDienstnehmer[];
}

interface ApiResponse {
  data: DashboardStats;
}

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  constructor(private httpClient: HttpClient) {}

  getStats(): Observable<DashboardStats> {
    const apiUrl = `${environment.serverUrl}/dashboard-stats`;
    return this.httpClient
      .get<ApiResponse>(apiUrl, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
        }),
      })
      .pipe(map((response) => response.data));
  }
}
